import { COMMON_WAIFUS, getCommonReviews } from '../../../constants.js';

export const AR_BASE = {
    hero: {
      title: "Waifu Briscola",
      tagline: "Briscola كما لم ترها من قبل: RPG و Waifu و AI.",
      ctaWeb: "العب على الويب",
      ctaAndroid: "تحميل للأندرويد",
      version: "الإصدار 2.3",
      badge: "✨ وضع الزنزانة الجديد"
    },
    stats: {
      downloads: "التنزيلات",
      downloadsValue: ["لا يمكن عدها!", "الخوادم ممتلئة", "الكثير!", "أكثر من 9000", "كثير جداً للعد"],
      hands: "الأيدي الخاسرة",
      handsValue: ["كثيرة جداً...", "مشكلة مهارة", "خطأ في الشبكة", "هل تبكي بعد؟", "حاول مرة أخرى ستكون محظوظاً"],
      rating: "التقييم",
      ratingValue: ["جدتي توافق", "11/10 - IGN", "أفضل من البيتزا", "لعبة العام 2026", "تحفة فنية مطلقة"],
      waifus: "Waifu",
      waifusValue: ["كلها لك", "فقط 2D > 3D", "اجمعها كلها!", "Waifu > Meta", "الكنز الحقيقي"]
    },
    features: {
      title: "أكثر بكثير من مجرد لعبة ورق",
      items: [
        { id: "classic", title: "Briscola كلاسيك", description: "التجربة الأصلية، مثالية ونظيفة.", icon: "🃏" },
        { id: "roguelike", title: "RPG روجلايك", description: "تسلق البرج، احصل على قوى العناصر واهزم الزعماء.", icon: "⚔️" },
        { id: "ai", title: "ذكاء اصطناعي حي", description: "بفضل Google Gemini، يقوم الخصوم بإهانتك أو مدحك في الوقت الفعلي.", icon: "🧠" },
        { id: "gacha", title: "نظام Gacha", description: "استخدم العملات لفتح جلود جديدة وخلفيات نادرة.", icon: "💎" },
        { id: "dungeon", title: "وضع الزنزانة", description: "واجه زعماء بقواعد مجنونة. هزيمة واحدة وتنتهي اللعبة.", icon: "🏰" },
        { id: "puzzle", title: "وضع الألغاز", description: "حل سيناريوهات معقدة بأهداف محددة.", icon: "🧩" }
      ]
    },
    video: { title: "إعلان أسلوب اللعب" },
    waifus: {
      title: "اختر شريكتك",
      subtitle: "كل شخصية لها شخصية فريدة ودبلجة وأسلوب لعب.",
      characters: [
        { ...COMMON_WAIFUS[0], name: "Miu", role: "اللطيفة", personality: "لطيفة ومشرقة، تحب أن تكون بقربك." },
        { ...COMMON_WAIFUS[1], name: "Rei", role: "المحللة", personality: "حسابية وباردة. منطق فقط." },
        { ...COMMON_WAIFUS[2], name: "Akame", role: "تسوندي", personality: "تنافسية ونارية. تكره الخسارة." },
        { ...COMMON_WAIFUS[3], name: "Lilith", role: "الملكة", personality: "ملكة البطاقات المظلمة." },
        { ...COMMON_WAIFUS[4], name: "Mochi", role: "الدليل", personality: "دليلك الموثوق... ربما." }
      ]
    },
    reviews: {
      title: "يقولون عنا (للأسف)",
      items: getCommonReviews('ar')
    },
    ctaStrip: {
      title: "جاهز للنزول إلى الملعب؟",
      subtitle: "انضم إلى لاعبين آخرين وابدأ مغامرتك اليوم.",
      button: "ابدأ اللعب الآن"
    },
    footer: { privacy: "الخصوصية", terms: "الشروط", copyright: "© 2026 Waifu Briscola" },
    privacy: {
      title: "سياسة الخصوصية لـ Waifu Briscola",
      lastUpdated: "آخر تحديث: 25 مايو 2024",
      intro: "تصف سياسة الخصوصية هذه كيفية إدارة معلوماتك عند استخدام تطبيق Waifu Briscola ('الخدمة').",
      sections: [
        {
          title: "المعلومات التي نجمعها",
          intro: "لتحسين تجربتك، نستخدم خدمات طرف ثالث قد تجمع معلومات:",
          items: [
            "بيانات الاستخدام (PostHog): نجمع بيانات تحليلية مجهولة أو بأسماء مستعارة حول كيفية تفاعلك مع اللعبة. يشمل ذلك أحداثاً مثل بدء اللعبة، والبطاقات التي تم لعبها، والنتائج النهائية. تساعدنا هذه البيانات على فهم كيفية استخدام اللعبة وكيف يمكننا تحسينها. لا نجمع معلومات تحديد الهوية الشخصية (PII) من خلال PostHog.",
            "تفاعلات الذكاء الاصطناعي (Google Gemini): يتم إرسال رسائل الدردشة التي ترسلها ومعلومات حول حالة اللعبة (مثل البطاقات في يدك وعلى الطاولة) إلى واجهة برمجة تطبيقات Google Gemini لإنشاء ردود وحركات الذكاء الاصطناعي. تخضع هذه التفاعلات لسياسة خصوصية Google. لا نرسل أي معلومات شخصية إلى Google بخلاف محتوى تفاعلاتك في اللعبة.",
          ],
        },
        {
          title: "كيف نستخدم معلوماتك",
          intro: "نستخدم المعلومات التي تم جمعها من أجل:",
          items: [
            "توفير وتشغيل وصيانة خدمتنا.",
            "تحسين وتخصيص وتوسيع خدمتنا.",
            "فهم وتحليل كيفية استخدامك لخدمتنا.",
            "منع إساءة الاستخدام وضمان الأمان.",
          ],
        },
        {
          title: "مشاركة المعلومات",
          body: "لا نشارك معلوماتك الشخصية مع أي شخص، باستثناء مقدمي الخدمات من الطرف الثالث (PostHog، Google) اللازمين لتشغيل التطبيق، كما هو موضح أعلاه.",
        },
        {
          title: "أمان البيانات",
          body: "أمان معلوماتك مهم بالنسبة لنا، لكن تذكر أنه لا توجد طريقة نقل عبر الإنترنت أو طريقة تخزين إلكتروني آمنة بنسبة 100%.",
        },
        {
          title: "التغييرات على سياسة الخصوصية هذه",
          body: "قد نقوم بتحديث سياسة الخصوصية الخاصة بنا من وقت لآخر. سنعلمك بأي تغييرات عن طريق نشر سياسة الخصوصية الجديدة على هذه الصفحة.",
        },
        {
          title: "اتصل بنا",
          body: "إذا كانت لديك أسئلة حول سياسة الخصوصية هذه، يمكنك الاتصال بالمسؤول Mauro Mazzocchetti.",
        },
      ],
    },
    consent: { text: "نستخدم ملفات تعريف الارتباط والتحليلات لتحسين الموقع. بالمتابعة فإنك توافق على", ok: "فهمت" },
    terms: {
      title: "الشروط والأحكام لـ Waifu Briscola",
      lastUpdated: "آخر تحديث: 25 مايو 2024",
      contact: "المسؤول: Mauro Mazzocchetti",
      intro: "مرحباً بكم في Waifu Briscola! توضح هذه الشروط والأحكام قواعد استخدام تطبيق Waifu Briscola ('الخدمة').",
      sections: [
        {
          title: "قبول الشروط",
          body: "من خلال الوصول إلى هذه الخدمة واستخدامها، فإنك توافق على الالتزام بهذه الشروط. إذا كنت لا توافق على أي جزء من الشروط، فلا يجوز لك استخدام الخدمة.",
        },
        {
          title: "استخدام الخدمة",
          body: "أنت توافق على عدم استخدام الخدمة لأي أغراض غير قانونية أو غير مصرح بها. أنت مسؤول عن سلوكك وعن أي محتوى تقدمه أثناء استخدام الخدمة، بما في ذلك رسائل الدردشة.",
        },
        {
          title: "المحتوى الناتج عن الذكاء الاصطناعي",
          intro: "تستخدم الخدمة نماذج الذكاء الاصطناعي (Google Gemini) لإنشاء ردود وتعليقات وحركات اللعبة. أنت تقر بأن:",
          items: [
            "المحتوى الناتج عن الذكاء الاصطناعي يتم إنتاجه بواسطة نموذج وقد لا يكون دقيقاً أو مناسباً أو متسقاً دائماً.",
            "نحن لسنا مسؤولين عن المحتوى الناتج عن الذكاء الاصطناعي.",
            "التفاعلات مع الذكاء الاصطناعي مخصصة لأغراض الترفيه فقط.",
          ],
        },
        {
          title: "حدود المسؤولية",
          body: "في أي حال من الأحوال، لن يكون Mauro Mazzocchetti أو شركاؤه مسؤولين عن أي أضرار غير مباشرة أو عرضية أو خاصة أو تبعية أو عقابية، بما في ذلك على سبيل المثال لا الحصر، خسارة الأرباح أو البيانات أو الشهرة أو الخسائر غير المادية الأخرى، الناتجة عن (i) وصولك إلى الخدمة أو استخدامها أو عدم قدرتك على الوصول إليها أو استخدامها؛ (ii) أي محتوى تم الحصول عليه من الخدمة.",
        },
        {
          title: "التغييرات في الشروط",
          body: "نحن نحتفظ بالحق، وفقاً لتقديرنا الخاص، في تعديل أو استبدال هذه الشروط في أي وقت. سنعلمك بأي تغييرات عن طريق نشر الشروط الجديدة على هذه الصفحة.",
        },
        {
          title: "القانون المعمول به",
          body: "تخضع هذه الشروط وتفسر وفقاً للقوانين الإيطالية، دون النظر إلى تعارضها مع أحكام القانون.",
        },
      ],
    }
};
